import { cn } from "@/lib/utils";

interface PowerLevelItemProps {
  variant: "text" | "quality" | "speed" | "fandom";
  value: number;
}

const PowerLevelItem: React.FC<PowerLevelItemProps> = ({ variant, value }) => {
  return (
    <div className="tw:flex tw:items-center tw:gap-1 tw:w-full tw:mb-1">
      <span className="tw:w-auto tw:min-w-10 tw:text-xxs tw:capitalize">
        {variant}
      </span>
      <div className="tw:flex tw:flex-1 tw:gap-0.5">
        {Array.from({ length: 5 }, (_, index) => {
          const active = index < value;

          return (
            <div
              className={cn(
                "tw:w-5 tw:h-[5px] tw:rounded-[3px] tw:bg-[#e0e0e0]",
                {
                  "tw:bg-[#933a3a]": variant === "text" && active,
                  "tw:bg-[#2a5e5e]": variant === "quality" && active,
                  "tw:bg-[#3b5998]": variant === "speed" && active,
                  "tw:bg-[#8a2be2]": variant === "fandom" && active,
                }
              )}
              key={`level-${index + 1}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default PowerLevelItem;
